module.exports = __webpack_public_path__ + "img/hub_maps.bb43e69b.svg";